class EventManager {
  constructor() {
    this.events = {};
    this.desub = [];
  }

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
    this.desub.push(() => {
      this.remove(event, callback);
    });
    return this.desub[this.desub.length - 1];
  }

  trigger(event, eventObject) {
    if (this.events[event]) {
      this.events[event].forEach(function(callback) {
        callback(eventObject || {});
      });
    }
  }

  remove(event, callback) {
    let foundAt = null;
    for (let i = 0; i < this.events[event].length; i++) {
      if (this.events[event][i] === callback) {
        foundAt = i;
        break;
      }
    }
    if (foundAt !== null) {
      this.events[event].splice(foundAt, 1);
    }
  }
}

export default new EventManager();



// WEBPACK FOOTER //
// ./src/js/services/EventManager.js